import { render, staticRenderFns } from "./NamesListModal.vue?vue&type=template&id=54c260a4&scoped=true&"
import script from "./NamesListModal.vue?vue&type=script&lang=js&"
export * from "./NamesListModal.vue?vue&type=script&lang=js&"
import style0 from "./NamesListModal.vue?vue&type=style&index=0&id=54c260a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c260a4",
  null
  
)

export default component.exports